<template>
  <div id="purchase_order_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area pt-0">
      <template v-if="cantAccessPage === true">
        <div class="page-name pb-1 order-part-header">
          <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
            <!-- Left section: Title or Create Part Order button -->
            <div v-if="isEditPage" class="text-left">
                            <span class="page-title" id="purchaseorderHeader" style="width: 100%;">Update Part
                                Order</span>
            </div>
            <div v-else class="text-left">
              <button :disabled="loadAllDealers" v-on:click.prevent="generateOrderNumber()"
                      class="btn btn-primary"
                      style="padding: 5px 4px; font-size: 1.25rem; font-weight: bold;">
                Create Part Order
              </button>
            </div>

            <!-- Right section: Process Order and Back button -->
            <div class="text-right">
              <button v-if="showReviewButton && isRizonRep" type="button" data-toggle="modal"
                      data-target="#orderCancelReview" class="btn btn-primary">
                Review Cancellation Request
              </button>
              <button v-if="isEditPage && isRizonRep && status == 'SUBMITTED'" type="button"
                      class="btn btn-primary" v-on:click.prevent="processOrder()">
                Process Order
              </button>
              <button type="submit" class="btn btn-secondary" v-on:click.prevent="PurchaseOrderList">
                <i class="fp-back"></i> Back
              </button>
            </div>
          </div>
          <!-- <button v-if="!isEditPage && !loadAllDealers" v-on:click.prevent="generateOrderNumber()"
              class="btn btn-primary">
              Create Part Order
          </button> -->
          <div class="row" style="padding-left: 2%;margin-top: 10px;">
            <div class="col header-font"><b>Order Number</b>: {{ orderNumber }}</div>
            <div class="col header-font"><b>Sales Id</b>: {{ saleId }}</div>
            <div class="col header-font">
              <b>Order Status</b>:
              <p :class="{ 'text-red': status == 'REQUESTED-FOR-CANCELLATION' }" style="display: inline;">
                {{ status }}
              </p>
            </div>
            <div class="col header-font"><b>Purchase Order</b>: {{ dealerPurchaseOrder }}</div>
          </div>
        </div>

        <div class="container-fluid mt-0">
          <div class="admin-page-content customer-po">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select"
                    id="PurchaseOrderForm">
                <div class="form-row row-cols-lg-3 row-cols-md-2 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label require" for="dealer_id">Bill To:</label>
                    <v-select v-if="loadAllDealers" v-model="dealer_id" name="dealer_id"
                              label="text" :filterable="false" :options="dealerArr"
                              @search="onSearchDealer" @change="billToChanged($event)" readonly
                              placeholder="Select Dealer" class='custom-ci-auto-search close-remove'
                              :disabled="disableAllFields">
                      <template slot="no-options">
                        Search Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <v-select v-else v-model="dealer_id" name="dealer_id" label="text"
                              :filterable="false" @change="billToChanged($event)" :options="dealerArr"
                              placeholder="Select Dealer" class='custom-ci-auto-search close-remove'
                              :disabled="disableAllFields">
                      <template slot="no-options">
                        Select Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ dealerErrorMsg }}</div>
                    <div class="mt-4 mb-3">
                      <div class="row">
                        <div class="col-4 pr-1">
                          <b>Company Name:</b>
                        </div>
                        <div class="col pl-1 d-flex align-items-end">
                          {{ dealerCompanyName }}
                        </div>
                      </div>
                      <div class="row">
                        <span class="col-4 pr-1"><b>Address:</b></span>
                        <span class="col pl-1">{{ dealerAddress_1 }}</span>
                      </div>
                      <div class="row" v-if="dealerAddress_2">
                        <span class="col-4 pr-1"></span>
                        <span class="col pl-1">{{ dealerAddress_2 }}</span>
                      </div>
                      <div class="row">
                        <span class="col-4 pr-1"><b>City:</b></span>
                        <span class="col pl-1">{{ dealerCity }}</span>
                      </div>
                      <div class="row">
                        <span class="col-4 pr-1"><b>{{state_province}}:</b></span>
                        <span class="col pl-1">{{ dealerState }}</span>
                      </div>
                      <div class="row">
                        <span class="col-4 pr-1"><b>{{zip_postal}}:</b></span>
                        <span class="col pl-1">{{ dealerZip }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col form-group ml-lg-5 ml-0">
                    <label class="control-label" :class="!shipNewAddress ? 'require' : ''"
                           for="dealerShipId">Ship To:</label>
                    <v-select v-model="dealerShipId" name="dealerShipId" label="text"
                              :filterable="false" @change="shipToChanged($event)" :options="dealerShipTo"
                              placeholder="Select Ship To" class='custom-ci-auto-search close-remove'
                              :disabled="disableAllFields || shipNewAddress">
                      <template slot="no-options">
                        Select Ship To...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ dealerShipToErrorMsg }}</div>
                    <div class="text-right mt-2">
                      <template v-if="shipNewAddress">
                        <button v-on:click.prevent="shipToNewAddress('cancel')"
                                class="btn btn-primary" :disabled="disableAllFields">
                          Cancel
                        </button>
                      </template>
                      <template v-else>
                        <button v-on:click.prevent="shipToNewAddress('add')"
                                class="btn btn-primary" :disabled="disableAllFields">
                          <i class="fp-add"></i>
                          Ship to New Address
                        </button>
                      </template>
                    </div>
                    <div class="mb-3 mt-1">
                      <div class="row">
                        <div class="col-4 pr-1 d-flex mt-1"
                             :class="shipNewAddress ? 'require' : ''">
                          <b>Company Name:</b>
                        </div>
                        <div v-if="!shipNewAddress" class="col pl-1 d-flex align-items-end">
                          {{ shipToCompanyName }}
                        </div>
                        <div class="col mt-1" v-else>
                          <input type="text" class="form-control"
                                 v-model="newShipToAddress.companyName"
                                 placeholder="Company Name" :disabled="disableAllFields">
                          <div v-if="newShipToAddress.companyNameErrorMsg"
                               class="field-error ml-0">{{
                              newShipToAddress.companyNameErrorMsg
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                                                <span class="col-4 pr-1 d-flex mt-1"
                                                      :class="shipNewAddress ? 'require' : ''"><b>Address:</b></span>
                        <div v-if="!shipNewAddress" class="col pl-1">{{
                            shipToAddress_1
                          }}
                        </div>
                        <div class="col mt-1" v-else>
                          <input type="text" class="form-control"
                                 v-model="newShipToAddress.address" placeholder="Address"
                                 :disabled="disableAllFields">
                          <div v-if="newShipToAddress.addressErrorMsg"
                               class="field-error ml-0">{{
                              newShipToAddress.addressErrorMsg
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="shipToAddress_2">
                        <span class="col-4 pr-1 d-flex mt-1"></span>
                        <div class="col pl-1">{{ shipToAddress_2 }}</div>
                      </div>
                      <div class="row">
                                                <span class="col-4 pr-1 d-flex mt-1"
                                                      :class="shipNewAddress ? 'require' : ''"><b>City:</b></span>
                        <div v-if="!shipNewAddress" class="col pl-1">{{ shipToCity }}</div>
                        <div class="col mt-1" v-else>
                          <input type="text" class="form-control"
                                 v-model="newShipToAddress.city" placeholder="City"
                                 :disabled="disableAllFields">
                          <div v-if="newShipToAddress.cityErrorMsg" class="field-error ml-0">
                            {{ newShipToAddress.cityErrorMsg }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                                                <span class="col-4 pr-1 d-flex mt-1"
                                                      :class="shipNewAddress ? 'require' : ''"><b>{{state_province}}:</b></span>
                        <div v-if="!shipNewAddress" class="col pl-1">{{ shipToState }}</div>
                        <div class="col mt-1" v-else>
                          <v-select v-model="newShipToAddress.state" id="state" name="state"
                                    data-info="Please select state" label="text" :filterable="false"
                                    :options="stateArr" @search="onSearchState"
                                    :placeholder="'Select ' + state_province" class="custom-ci-auto-search"
                                    ref="state" :disabled="disableAllFields">
                            <template slot="no-options">
                              Search State...
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.text }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.text }}
                              </div>
                            </template>
                          </v-select>
                          <div v-if="newShipToAddress.stateErrorMsg" class="field-error ml-0">
                            {{ newShipToAddress.stateErrorMsg }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                                                <span class="col-4 pr-1 d-flex mt-1"
                                                      :class="shipNewAddress ? 'require' : ''"><b>{{zip_postal}}:</b></span>
                        <div v-if="!shipNewAddress" class="col pl-1">{{ shipToZip }}</div>
                        <div class="col mt-1" v-else>
                          <input type="text" class="form-control"
                                 v-model="newShipToAddress.zip" :placeholder="zip_postal"
                                 :disabled="disableAllFields">
                          <div v-if="newShipToAddress.zipErrorMsg" class="field-error ml-0">{{
                              newShipToAddress.zipErrorMsg
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row row-cols-lg-3 row-cols-md-2 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label" for="orderDate">Order Date:</label>
                    <div class="input-group">
                      <date-picker placeholder="MM/DD/YYYY" disabled id="orderDate"
                                   name="orderDate" v-model="orderDate"
                                   :config="optionsDate"></date-picker>
                      <label for="orderDate" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ orderDateErrorMsg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="attention">Attention</label>
                    <input type="text" placeholder="Attention" class="form-control"
                           v-model="attention" name="attention" id="attention"
                           :disabled="disableAllFields">
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="orderedBy">Ordered
                      By</label>
                    <input type="text" class="form-control" v-model="orderedBy" name="orderedBy"
                           id="orderedBy" disabled>
                  </div>
                </div>
                <hr>

                <div class="form-row row-cols-md-3 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label require" for="orderType">Order Type:</label>
                    <v-select v-model="orderType" name="orderType" placeholder="Select Order Type"
                              label="text" :options="orderTypeArr" @change="orderTypeChanged($event)"
                              :disabled="disableAllFields">
                    </v-select>
                    <div class="field-error">{{ orderTypeErrorMsg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="dealerPurchaseOrder">Dealer Purchase
                      Order:</label>
                    <input type="text" class="form-control" v-model="dealerPurchaseOrder"
                           name="dealerPurchaseOrder" id="dealerPurchaseOrder"
                           placeholder="Dealer Purchase Order" :disabled="disableAllFields">
                    <div class="field-error">{{ dealerPurchaseOrderErrorMsg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="comment">Comments:</label>
                    <textarea name="comment" class="form-control" id="comment" v-model="comment"
                              placeholder="Comment" :disabled="disableAllFields"></textarea>
                    <div class="field-error">{{ commentErrorMsg }}</div>
                  </div>
                </div>

                <div v-if="orderType == 'Vehicle Off Road'" class="form-row row-cols-md-3 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label"
                           :class="orderType == 'Vehicle Off Road' ? 'require' : ''">Full VIN:</label>
                    <v-select v-model="vin" id="vin" name="vin" label="text" :filterable="false"
                              :options="vinArr" @search="onSearchAssetWithVin"
                              placeholder="Search Vehicle with Vin"
                              class='custom-ci-auto-search close-remove' :disabled="disableAllFields">
                      <template slot="no-options">
                        Please Enter a Valid VIN!
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ vinErrorMsg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label"
                           :class="orderType == 'Vehicle Off Road' ? 'require' : ''"
                           for="repairOrder">Repair
                      Order:</label>
                    <input type="text" class="form-control" v-model="repairOrder" name="repairOrder"
                           id="repairOrder" placeholder="Repair Order" :disabled="disableAllFields">
                    <div class="field-error">{{ repairOrderErrorMsg }}</div>
                  </div>
                </div>

                <div class="btn-groups">
                  <a href="javascript:void(0)" class="btn btn-secondary pull-right ml-1 mb-2"
                     v-on:click="openModal()" :class="{ 'custom-disabled-link': disableAllFields }">
                    <i class="fp-export"></i> Import
                  </a>
                </div>
                <div class="purchase-order-create-main form-group table-responsive-sm">
                  <table aria-describedby="table" class="table table-sm table-bordered font-1">
                    <thead>
                    <tr class="table-primary">
                      <th scope="col" style="width: 20%;">Part Number</th>
                      <th scope="col" style="width: 20%;">Description</th>
                      <th scope="col">QTY Ordered</th>
                      <th scope="col">QTY Filled</th>
                      <th scope="col">QTY Backordered</th>
                      <th scope="col">Price ea.</th>
                      <th scope="col">Total</th>
                      <th scope="col">Delete Line</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                      <td>
                        <v-select v-model="row.part" name="part" id="part" label="text"
                                  :filterable="false" :options="componentArr"
                                  @search="onSearchComponent" @input="populateUnitPrice(index)"
                                  placeholder="Select Part"
                                  class="custom-ci-auto-search contract-data"
                                  @change="partChanged($event, index)"
                                  :disabled="disableAllFields">
                          <template slot="no-options">
                            Search Part...
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.text }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.text }}
                            </div>
                          </template>
                        </v-select>
                        <div class="field-error">{{ row.partErrorMsg }}</div>
                      </td>
                      <td>
                        <input type="text" placeholder="Description"
                               v-model="row.partDescription" class="form-control"
                               :name="'partDescription_' + index"
                               :id="'partDescription_' + index" disabled>
                      </td>
                      <td>
                        <input type="text" placeholder="Quantity Ordered"
                               v-model="row.qtyOrdered" :name="'quantityOrdered_' + index"
                               v-on:keyup="calculatePartAmount(index)"
                               id="'quantityOrdered_' + index" class="form-control text-right"
                               @keypress="filterWholeNumericValue($event)"
                               @input="validateQty($event,row)"
                               :disabled="disableAllFields">
                        <div class="field-error">{{ row.qtyOrderedErrorMsg }}</div>
                      </td>
                      <td>
                        <input type="text" placeholder="Quantity Filled"
                               v-model="row.qtyFilled" name="quantityFilled"
                               v-on:keyup="calculatePartAmount(index)" id="quantityFilled"
                               class="form-control text-right"
                               @keypress="isNumberCheck($event, index, 'qty')"
                               :disabled="disableRizonFields">
                        <div class="field-error">{{ row.qtyFilledErrorMsg }}</div>
                      </td>
                      <td>
                        <input type="text" placeholder="Quantity Backordered"
                               v-model="row.qtyBackordered" name="quantityBackorderd"
                               v-on:keyup="calculatePartAmount(index)" id="quantityBackorderd"
                               class="form-control text-right"
                               @keypress="isNumberCheck($event, index, 'qty')"
                               :disabled="disableRizonFields">
                        <div class="field-error">{{ row.qtyBackorderedErrorMsg }}</div>
                      </td>
                      <td>
                        <input type="text" disabled placeholder="Price"
                               v-model="row.unitPrice" @input="validateRawInput($event, index)"
                               v-on:keyup="calculatePartAmount(index)"
                               @keypress="isNumberCheck($event, index, 'price')"
                               name="unitPrice" class="form-control text-right">
                        <div class="field-error">{{ row.unitPriceErrorMsg }}</div>
                      </td>
                      <td>
                        <input type="text" disabled placeholder="Total Amount"
                               v-model="row.amount" id="totalAmount" name="totalAmount"
                               class="form-control text-right">
                      </td>
                      <td class="text-center valign-middle">
                        <template v-if="rows.length != 1">
                          <a href="javascript:void(0);" class="close-row"
                             v-on:click="removeElement(index);"
                             :class="{ 'custom-disabled-link': disableAllFields }"> <i
                            class="fp-delete"></i> </a>
                        </template>
                        <template v-else>
                          <span class="close-row"> _ </span>
                        </template>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="btn-groups">
                  <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary"
                          :disabled="disableAllFields">
                    <i class="fp-add"></i> Add Row
                  </button>
                </div>
                <div class="order-summary mt-4">
                  <div class="row">
                    <div class="col-md-4 offset-md-8">
                      <div class="bg-white radius-5 pl-3 pr-3 pt-3 pb-1">
                        <table aria-describedby="table" class="table table-sm table-bordered">
                          <tbody>
                          <tr>
                            <td>Subtotal:</td>
                            <td class="text-right">
                              ${{ amountFormat(subTotal.toFixed(2)) }}
                            </td>
                          </tr>
                          <tr class="table-secondary">
                            <td>Total:</td>
                            <td class="order-total text-right">${{
                                amountFormat(
                                  total.toFixed(2))
                              }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="pl-3 pr-3">
                        <p style="color: red;">Any applicable freight charges will be calculated
                          and added to your
                          invoice</p>
                      </div>
                    </div>
                  </div>
                </div>
<!--                Removing the agreement checkbox for now, todo add it later once we have the proper text. -->
<!--                <div class="col-md-12">
                  <div class="col pl-0">
                    <div class="form-group d-flex legal_notice_checbox mb-1">
                      <input class="mr-2 align-self-start mt-1" type="checkbox"C
                             v-model="agreeLegal" name="agreeLegal" id="agreeLegal"
                             :disabled="disableAllFields"/>
                      <label class="form-check-label require" for="agreeLegal"
                             style="color: black;font-size: 14px;">
                        Agreement
                      </label>
                    </div>
                    <div class="field-error ml-1">{{ agreeLegalErrorMsg }}</div>
                  </div>
                </div>-->
                <div class="form-group">
                  <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert"
                            aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
                <div class="btn-groups mt-3">
                  <button type="submit" id="submitPurchaseOrderBtn" class="btn btn-primary"
                          v-on:click.prevent="showSwalPopUp('submit')" :disabled="disableAllFields">
                    Submit Order
                  </button>
                  <button type="submit" v-if="$route.params.id > 0" id="updatePurchaseOrderBtn"
                          class="btn btn-primary" v-on:click.prevent="CreatePurchaseOrder"
                          :disabled="disableAllFields && disableRizonFields">
                    Update and Close
                  </button>
                  <button type="submit" v-else id="savePurchaseOrderBtn" class="btn btn-primary"
                          v-on:click.prevent="CreatePurchaseOrder" :disabled="disableAllFields">
                    Save and Close
                  </button>
                  <button type="button" v-if="!isEditPage" id="clearPurchaseOrderBtn"
                          class="btn btn-primary" v-on:click.prevent="clearAllSwal"
                          :disabled="disableAllFields">
                    Clear Content
                  </button>
                  <button type="button" id="cancelPurchaseOrderBtn" class="btn btn-primary"
                          :disabled="disableCancelOrder" v-on:click.prevent="orderCancellationCheck">
                    Cancel Order
                  </button>
                </div>
                <hr class="mb-0">

                <!-- comment history -->
                <div class="order-summary mt-1">
                  <div class="row">
                    <div class="col-md-12 pl-0">
                      <div class="bg-white radius-5 pl-3 pr-3 pt-3">
                        <div class="d-flex align-items-center justify-content-between">
                          <h4>Comment History</h4>
                          <button class="btn btn-primary" type="button"
                                  v-on:click="openCommentModal()"
                                  :disabled="disableCommentButton">
                            Add Comment
                          </button>
                        </div>
                        <template>
                          <template v-if="commentArr.length > 0">
                            <ul class="comment-box">
                              <li v-for="(responses, key) in commentArr">
                                <div class="comment-details">
                                  <div class="comment-dec">
                                                                        <span class="user">{{
                                                                            responses.createdUser
                                                                          }}</span>
                                    <span class="ml-2 comment-time">{{
                                        responses.comment_date
                                      }}</span>
                                  </div>
                                  <p class="mb-1">{{ responses.comment }}</p>
                                </div>
                              </li>
                            </ul>
                          </template>
                          <template v-else>
                            <p class="no-data"> No comment available </p>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </section>

            <!-- Rizon rep part -->
            <section v-if="isRizonRep" class="internal-container border-top-table-fl">
              <h4><strong>Rizon Parts Department Internal</strong></h4>
              <div class="form-row row-cols-lg-3 row-cols-md-2 row-cols-1 mb-3">
                <div class="col form-group">
                  <label class="control-label require" for="status">Status:</label>
                  <v-select v-model="status" name="status" placeholder="Select Status" label="text"
                            :options="statusArr" :disabled="disableRizonFields">
                  </v-select>
                  <div class="field-error">{{ statusErrorMsg }}</div>
                </div>
              </div>

              <div class="purchase-order-create-main form-group table-responsive-sm">
                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                  <thead>
                  <tr class="table-primary">
                    <th scope="col">Invoice Number</th>
                    <th scope="col">Invoice Date</th>
                    <th scope="col">Ship Date</th>
                    <th scope="col">Tracking Number</th>
                    <th scope="col" style="width: 15%;">Carrier</th>
                    <th scope="col" style="width: 5%;">Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in invoicesRows" :key="index">
                    <td>
                      <input type="text" placeholder="Invoice Number"
                             v-model="row.invoiceNumber" name="invoiceNumber" id="invoiceNumber"
                             class="form-control" :disabled="disableRizonFields">
                      <div class="field-error">{{ row.invoiceNumberErrorMsg }}</div>
                    </td>
                    <td>
                      <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="invoiceDate"
                                     name="invoiceDate" v-model="row.invoiceDate"
                                     :config="optionsDate"
                                     :disabled="disableRizonFields"></date-picker>
                        <label for="invoiceDate"
                               class="fp-calendar input-calender-icon"></label>
                      </div>
                      <div class="field-error">{{ row.invoiceDateErrorMsg }}</div>
                    </td>
                    <td>
                      <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="shipDate" name="shipDate"
                                     v-model="row.shipDate" :config="optionsDate"
                                     :disabled="disableRizonFields"></date-picker>
                        <label for="shipDate"
                               class="fp-calendar input-calender-icon"></label>
                      </div>
                      <div class="field-error">{{ row.shipDateErrorMsg }}</div>
                    </td>
                    <td>
                      <input type="text" placeholder="Tracking Number"
                             v-model="row.trackingNumber" name="trackingNumber"
                             id="trackingNumber" class="form-control"
                             :disabled="disableRizonFields">
                      <div class="field-error">{{ row.trackingNumberErrorMsg }}</div>
                    </td>
                    <td>
                      <input type="text" placeholder="Carrier"
                             v-model="row.carrier" name="carrier"
                             id="carrier" class="form-control"
                             :disabled="disableRizonFields">
                      <div class="field-error">{{ row.carrierErrorMsg }}</div>
                    </td>
                    <td class="text-center valign-middle">
                      <template v-if="invoicesRows.length != 1">
                        <a href="javascript:void(0);" class="close-row"
                           v-on:click="removeInvoiceElement(index);"> <i
                          class="fp-delete"></i>
                        </a>
                      </template>
                      <template v-else>
                        <span class="close-row"> _ </span>
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="btn-groups">
                <button type="submit" :disabled="disableRizonFields"
                        v-on:click.prevent="addInvoiceRow()" class="btn btn-primary mb-2">
                  <i class="fp-add"></i> Add Row
                </button>
              </div>

              <h5>Change Log</h5>
              <div class="purchase-order-create-main form-group table-responsive-sm">
                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                  <thead>
                  <tr class="table-primary">
                    <th scope="col">User</th>
                    <th scope="col">Date</th>
                    <th scope="col">Time</th>
                    <th scope="col">Note</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="changeLogRows.length > 0">
                    <tr v-for="(row, index) in changeLogRows" :key="index">
                      <td>{{ row.user }}</td>
                      <td>{{ row.date }}</td>
                      <td>{{ row.time }}</td>
                      <td>{{ row.note }}</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr class="text-center">
                      <td colspan="4">No Data</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
              <div class="btn-groups">
                <button type="button" :disabled="disableRizonFields" v-on:click="saveInvoiceDetails()"
                        class="btn btn-primary">
                  Save
                </button>

                <button type="button" v-on:click.prevent="PurchaseOrderList" class="btn btn-primary">
                  Cancel
                </button>
                <button v-if="showReviewButton" type="button" data-toggle="modal"
                        data-target="#orderCancelReview" class="btn btn-primary">
                  Review Cancellation Request
                </button>
              </div>
            </section>

            <!-- import modal -->
            <div class="modal fade policy-modal" id="item-modal" ref="item-modal" data-backdrop="static"
                 data-keyboard="false" aria-labelledby="item-modal" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Select File</h5>
                  </div>
                  <div class="modal-body">
                    <form id="importFile" class="addinspectionForm">
                      <div class="form-row">
                        <div class="col form-group">
                          <label class="control-label require mb-2"
                                 for="name">File:</label><br/>
                          <input id="dnFile" type="file" @change="onFileChanged">
                          <div class="field-error">{{ import_error }}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col form-group" v-if="sampleFileName != ''">
                          <label class="control-label"> Download Sample file </label>
                          <a href="javascript:void(0)" v-on:click="downloadSample()"> <i
                            class="fp-text-document"></i>
                            {{ sampleFileName }} </a>
                        </div>
                      </div>
                      <span class="field-error">Please use different browser, if sample file
                                                download do not work.</span>

                    </form>

                    <div class="modal-footer">
                      <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"><i
                        class="fp-close">
                      </i>Cancel
                      </button>
                      <button class="btn btn-primary" id="importButton" v-on:click="importItem()">
                        <i class="fp-import"> </i> Import
                      </button>
                    </div>

                    <div class="mt-2" style="color: red;">
                      <p class="text-center">Importing a parts list will override all parts that
                        have been entered
                        manually</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- order cancel modal -->
            <div class="modal fade policy-modal" id="orderCancelModal" data-backdrop="static"
                 data-keyboard="false" aria-labelledby="item-modal" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Order Cancellation Request</h5>
                  </div>
                  <div class="modal-body">
                    <p>
                      <strong style="color: red;">NOTICE</strong>
                      {{ cancellationRequestMsg }}
                    </p>
                    <label for="reason-for-cancellation" class="font-weight-bold require">Reason for
                      cancellation?</label>
                    <textarea id="reason-for-cancellation" v-model.trim='reasonForCancellation'
                              class="form-control" rows="5"></textarea>
                    <div class="field-error">{{ reasonForCancellationErrorMsg }}</div>


                    <div class="modal-footer">
                      <button class="btn btn-primary" type="button" id="submitCancelModalButton"
                              v-on:click.prevent="cancelOrder">
                        Submit
                      </button>
                      <button class="btn btn-tertiary" type="button" id="cancelModalButton"
                              data-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- cancellation ineligibility modal -->
            <div class="modal fade policy-modal" id="orderCancelIneligibleModal" data-backdrop="static"
                 data-keyboard="false" aria-labelledby="item-modal" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Unable to cancel order</h5>
                  </div>
                  <div class="modal-body">
                    <p>
                      <strong style="color: red;">NOTICE</strong>
                      This Order cannot be canceled as the invocie number and tracking number has
                      already been generated.
                    </p>

                    <div class="modal-footer">
                      <button class="btn btn-tertiary" type="button" id="cancelModalButton"
                              data-dismiss="modal">
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- cancellation approval modal -->
            <div class="modal fade policy-modal" id="orderCancelReview" data-backdrop="static"
                 data-keyboard="false" aria-labelledby="item-modal" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Review Order Cancellation Request</h5>
                  </div>
                  <div class="modal-body">
                    <label for="reason-for-cancellation" class="font-weight-bold require">
                      Add comment for Approving/Denying the order cancellation request.
                    </label>
                    <textarea id="reason-for-cancellation" v-model.trim='approvalDenialReason'
                              class="form-control" rows="5"></textarea>
                    <div class="field-error">{{ approvalDenialReasonErrorMsg }}</div>


                    <div class="modal-footer">
                      <button class="btn btn-primary" type="button"
                              v-on:click.prevent="orderCancelReview('approve')">
                        Approve
                      </button>
                      <button class="btn btn-primary" type="button"
                              v-on:click.prevent="orderCancelReview('deny')">
                        Deny
                      </button>
                      <button class="btn btn-tertiary" type="button" id="cancelModalButton"
                              data-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- rizon rep save modal -->
            <div class="modal fade policy-modal" id="rizonSaveModal" data-backdrop="static"
                 data-keyboard="false" aria-labelledby="item-modal" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">{{ rizonSaveModalTitle }}</h5>
                  </div>
                  <div class="modal-body">
                    <label for="rizon-notes" class="font-weight-bold require">Notes</label>
                    <textarea id="rizon-notes" v-model="rizonSaveNotes" class="form-control"
                              rows="5"></textarea>
                    <div class="field-error">{{ rizonSaveNotesErrorMsg }}</div>
                    <div class="modal-footer">
                      <button v-if="!deleteInvoiceRow" class="btn btn-primary" type="button"
                              id="submitSaveModalButton" v-on:click="AddInvoiceDetails()">
                        Submit
                      </button>
                      <button v-if="deleteInvoiceRow" class="btn btn-primary" type="button"
                              id="submitSaveModalButton" v-on:click="DeleteInvoiceLineItem()">
                        Submit
                      </button>
                      <button class="btn btn-tertiary" type="button" id="saveModalButton"
                              data-dismiss="modal" v-on:click="resetRizonModal()">
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- add comment modal -->
            <div class="modal fade policy-modal" id="addCommentModal" ref="addCommentModal"
                 data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">New Comment</h5>
                  </div>
                  <div class="modal-body">
                                        <textarea class="form-control" v-model.trim="newComment" rows="3"
                                                  maxlength="3000" placeholder="Write comment"></textarea>
                    <div class="col-md-12 mt-0 pr-0 text-right">
                      <span>{{ newCommentCharsCount }}/3000</span>
                    </div>
                    <span v-if="newCommentErrorMsg" class="field-error">{{
                        newCommentErrorMsg
                      }}</span>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-primary" type="button"
                            v-on:click="addComment()">Submit
                    </button>
                    <button class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import moment from 'moment';

export default {
  name: "VendorPurchaseOrderCreate",
  metaInfo() {
    return {
      title: (this.$route.params.id > 0) ? "Update Part Order | " + process.env.COPYRIGHT_NAME : "Create Part Order | " + process.env.COPYRIGHT_NAME
    }
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    loadAllDealers: false,
    cantAccessPage: '',
    loading: false,
    showProcessBtn: false,
    dealerArr: [],
    sampleFileName: null,
    sampleFile: null,
    import_error: null,
    dealer_id: '',
    dealerErrorMsg: '',
    dealerShipTo: [],
    dealerShipId: '',
    dealerShipToErrorMsg: '',
    orderDate: '',
    orderDateErrorMsg: '',
    optionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: true,
    },
    isEditPage: false,
    attention: '',
    orderedBy: '',
    dealerDetails: {},
    dealerCompanyName: '',
    dealerAddress_1: '',
    dealerAddress_2: '',
    dealerCity: '',
    dealerState: '',
    dealerZip: '',
    shipToCompanyName: '',
    shipToAddress_1: '',
    shipToAddress_2: '',
    shipToCity: '',
    shipToState: '',
    shipToZip: '',
    orderTypeArr: [
      'Emergency',
      'Recall/Field Fix',
      'Stock',
      'Vehicle Off Road'
    ],
    orderType: '',
    orderTypeErrorMsg: '',
    dealerPurchaseOrder: '',
    dealerPurchaseOrderErrorMsg: '',
    comment: '',
    commentErrorMsg: '',
    componentArr: [],
    rows: [],
    subTotal: 0,
    total: 0,
    isRizonRep: false,
    agreeLegal: false,
    agreeLegalErrorMsg: '',
    vin: '',
    vinArr: [],
    vinErrorMsg: '',
    repairOrder: '',
    repairOrderErrorMsg: '',
    statusArr: [
      'BACKORDER',
      'CANCELED',
      'IN-PROCESS',
      'INVOICED',
      'PARTIALLY SHIPPED',
      'REQUESTED-FOR-CANCELLATION',
      'SHIPPED',
      'SUBMITTED'
    ],
    status: '',
    statusErrorMsg: '',
    invoicesRows: [],
    changeLogRows: [],
    reasonForCancellation: '',
    rizonSaveNotes: '',
    rizonSaveNotesErrorMsg: '',
    commentArr: [],
    newComment: '',
    newCommentErrorMsg: '',
    newCommentCharsCount: 0,
    userObj: '',
    partOrderId: '',
    disableRizonFields: true,
    orderNumber: '',
    savedDealerShipToId: null,
    savedDealerId: null,
    shipNewAddress: false,
    newShipToAddress: {
      'companyName': '',
      'companyNameErrorMsg': '',
      'address': '',
      'addressErrorMsg': '',
      'city': '',
      'cityErrorMsg': '',
      'state': '',
      'stateErrorMsg': '',
      'zip': '',
      'zipErrorMsg': '',
    },
    stateArr: [],
    rizonSaveModalTitle: "Add Notes",
    deleteInvoiceRow: false,
    invoiceIndexToDelete: 0,
    disableAllFields: false,
    bypassConfirmation: false, // Flag to bypass confirmation dialogs
    reasonForCancellationErrorMsg: "",
    approvalDenialReason: '',
    approvalDenialReasonErrorMsg: '',
    cancellationRequestMsg: "Orders may only be canceled if they have NOT been invoiced or if NO tracking number has been issued.",
    disableCancelOrder: false,
    disableCommentButton: false,
    showReviewButton: false,
    partOrderFormData: "",
    initialPartOrderFormData: "",
    orderJustLoaded: false,
    saleId: ""
  }),
  beforeRouteLeave(to, from, next) {
    if (this.bypassConfirmation) {
      next();
    } else {
      this.populateFormData();
      if (this.hasFormChanged()) {
        if (confirm("Changes you made may not be saved.")) {
          next(); // Proceed with navigation
        }
      } else {
        next();
      }
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'ev_add_part_order') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == 'ev_load_all_dealer_dropdown') {
            self.loadAllDealers = true;
            self.isRizonRep = true;
            self.disableAllFields = true;
          }
        }
        if (!self.loadAllDealers) {
          let userObj = JSON.parse(localStorage.getItem("user_obj"));
          self.loadUserDealerMapper(userObj.id);
        }
        if (self.isEditPage) {
          self.loadCustomerPurchaseOrder();
        }
      }
    },
    dealer_id: function (newValue) {
      if (newValue !== '' || newValue !== null) {
        if (newValue.value != undefined && newValue.value != '') {
          this.dealerShipId = '';
          this.loading = true;
          this.loadFieldData(['dealerShipTo', 'dealerDetails'], '', newValue.value);

          if (this.isEditPage) {
            // After all updates and function calls, use $nextTick to ensure the DOM is updated
            this.$nextTick(() => {
              this.populateFormData(true);
              this.loading = false; // Finally set loading to false after everything is done
            });
          }
        }
      }
    },
    dealerDetails: {
      handler: function (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.dealerCompanyName = newVal.company_name || '';
          this.dealerAddress_1 = newVal.address_1 || '';
          this.dealerAddress_2 = newVal.address_2 || '';
          this.dealerCity = newVal.city || '';
          this.dealerState = newVal.state || '';
          this.dealerZip = newVal.zip || '';
        } else {
          this.clearBillToDetails();
        }
      },
      deep: true
    },
    dealerShipId: {
      handler: function (newVal) {
        if (newVal) {
          if (this.orderJustLoaded) {
            this.populateFormData(true);
          }
          this.orderJustLoaded = false;
          this.shipToCompanyName = newVal.company_name || '';
          this.shipToAddress_1 = newVal.address || '';
          this.shipToAddress_2 = '';
          this.shipToCity = newVal.city || '';
          this.shipToState = newVal.state_id.text || '';
          this.shipToZip = newVal.zipcode || '';
        } else {
          this.clearShipToDetails();
        }
      },
    },
    subTotal: function () {
      var self = this;
      self.total = Number(self.getNum(self.subTotal));
    },
    newComment: function (newValue) {
      if (newValue.length > 3000) {
        this.newComment = newValue.substring(0, 3000);
      }
      this.newCommentCharsCount = newValue.length;
    },
    dealerShipTo: function () {
      if (this.isEditPage && this.savedDealerShipToId != null) {
        for (let i = 0; i < this.dealerShipTo.length; i++) {
          if (this.dealerShipTo[i].value == this.savedDealerShipToId) {
            this.dealerShipId = this.dealerShipTo[i];
            break;
          }
        }
      }
    },
    dealerArr: function () {
      if (
        this.isEditPage
        &&
        this.savedDealerId != null
        &&
        (this.dealer_id == '' || this.dealer_id == null)
      ) {
        this.populateDealerId();
      }
    },
  },
  mounted: function () {
    var self = this;
    var userObjString = localStorage.getItem("user_obj");
    if (userObjString != null) {
      self.userObj = JSON.parse(userObjString);
    }

    if (self.$route.params.id > 0) {
      self.isEditPage = true;
      self.partOrderId = self.$route.params.id;
      this.bypassConfirmation = false;
    } else {
      this.bypassConfirmation = true;
      this.disableAllFields = true;
      self.orderedBy = self.userObj != '' ? self.userObj.email : '';
      this.updateCancellationRequestMessage();
      this.cancelButtonAccess();
      this.disableCommentButton = true;
    }
    self.getPermissions();

    if (!self.isEditPage) {
      self.addPurchaseOrderItem();

      self.invoicesRows.push({
        id: 0,
        invoiceNumber: '',
        invoiceDate: '',
        shipDate: '',
        trackingNumber: '',
        carrier: '',
        invoiceNumberErrorMsg: '',
        invoiceDateErrorMsg: '',
        shipDateErrorMsg: '',
        trackingNumberErrorMsg: '',
        carrierErrorMsg: ''
      });
    }
  },
  methods: {
    beforeWindowUnload(event) {
      if (!this.bypassConfirmation) {
        this.populateFormData();
        if (this.hasFormChanged()) {
          event.preventDefault();
          event.returnValue = '';
        }
      }
    },
    shipToNewAddress(flag) {
      if (flag == 'add') {
        this.dealerShipId = '';
        this.shipNewAddress = true;
      } else {
        this.shipNewAddress = false;
        this.clearNewShipToFields();
      }
    },
    clearNewShipToFields() {
      this.newShipToAddress.companyName = '';
      this.newShipToAddress.address = '';
      this.newShipToAddress.city = '';
      this.newShipToAddress.state = '';
      this.newShipToAddress.zip = '';
      this.newShipToAddress.companyNameErrorMsg = '';
      this.newShipToAddress.addressErrorMsg = '';
      this.newShipToAddress.cityErrorMsg = '';
      this.newShipToAddress.stateErrorMsg = '';
      this.newShipToAddress.zipErrorMsg = '';
      this.dealerErrorMsg = '';
    },
    onSearchState(search, loading) {
      var self = this;
      if ((search.trim()).length > 0) {
        loading(true);
        self.searchField(loading, search, 'state', '');
      }
    },
    billToChanged(value) {
      if (value == '' || value == null) {
        this.clearBillToDetails();
      }
    },
    shipToChanged(value) {
      if (value == '' || value == null) {
        this.clearShipToDetails();
      }
    },
    clearShipToDetails() {
      this.dealerShipId = '';
      this.shipToCompanyName = '';
      this.shipToAddress_1 = '';
      this.shipToAddress_2 = '';
      this.shipToCity = '';
      this.shipToState = '';
      '';
      this.shipToZip = '';
    },
    clearBillToDetails() {
      this.dealer_id = '';
      this.dealerCompanyName = '';
      this.dealerAddress_1 = '';
      this.dealerAddress_2 = '';
      this.dealerCity = '';
      this.dealerState = '';
      this.dealerZip = '';
    },
    openCommentModal() {
      this.newComment = '';
      this.newCommentErrorMsg = '';
      $('#addCommentModal').modal('show');
    },
    orderTypeChanged(newVal) {
      if (newVal == '' || newVal == null) {
        this.orderType = '';
      }
    },
    onSearchDealer(search, loading) {
      if (this.loadAllDealers) {
        if (search.length > 2) {
          if (typeof loading === 'function') {
            loading(true); // Call the loading function if it's a function
          } else {
            this.loading = true;
          }
          this.searchField(loading, search, 'dealer', '');
        }
      }
    },
    onSearchAssetWithVin(search, loading) {
      var self = this;
      if (search.length > 3) {
        if (typeof loading === 'function') {
          loading(true);
        } else {
          self.loading = true;
        }
        self.searchField(loading, search, 'vehicle_vin', '');
      }
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      var self = this;
      self.selectedFile = file;
      self.import_error = '';
    },
    onSearchComponent(search, loading) {
      var self = this;
      if (search.length > 1) {
        loading(true);
        self.searchField(loading, search, 'part_number', '');
      }
    },
    partChanged(value, index) {
      if (value == '' || value == null) {
        this.rows[index].part = '';
        this.populateUnitPrice(index);
      }
    },
    populateUnitPrice(index) {
      var self = this;
      self.clearPartsFields(index);
      if (
        self.rows[index].part != undefined
        &&
        self.rows[index].part != ""
        &&
        self.rows[index].part != null
      ) {
        self.checkDuplicatePart('populateUnitPrice')
        self.rows[index].unitPrice = "$" + self.amountFormat(self.rows[index].part.base_price);
        self.rows[index].partDescription = self.rows[index].part.description;
      }
      self.calculatePartAmount(index);
    },
    checkDuplicatePart(flag = null) {
      let hasDuplicates = false;
      const partValues = [];
      if (flag == 'populateUnitPrice') {
        // Collect part values from all rows
        for (let i = 0; i < this.rows.length; i++) {
          this.clearPartRowErrorMsg(i);
          partValues.push(this.rows[i].part.value);
        }
      } else {
        for (let i = 0; i < this.rows.length; i++) {
          partValues.push(this.rows[i].part.value);
        }
      }


      // Check for duplicates in the partValues array
      for (let i = 0; i < partValues.length; i++) {
        for (let j = i + 1; j < partValues.length; j++) {
          if (partValues[i] === partValues[j]) {
            hasDuplicates = true;

            // Set error message on the duplicate row
            this.rows[j].partErrorMsg = "Duplicate Part Number cannot be selected";
            this.rows[i].partErrorMsg = "Duplicate Part Number cannot be selected";
          }
        }
      }
      return hasDuplicates;
    },
    clearPartsFields(index) {
      this.rows[index].partDescription = '';
      this.rows[index].qtyOrdered = '';
      this.rows[index].qtyFilled = '';
      this.rows[index].qtyBackordered = '';
      this.rows[index].unitPrice = "$" + 0;
      this.rows[index].amount = "$" + 0;
      this.rows[index].partErrorMsg = '';
      this.rows[index].qtyOrderedErrorMsg = '';
      this.rows[index].qtyFilledErrorMsg = '';
      this.rows[index].qtyBackorderedErrorMsg = '';
      this.rows[index].unitPriceErrorMsg = '';
    },
    isNumberCheck: function (evt, index, type) {
      var self = this;
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
        evt.preventDefault();
      } else {
        if (type == 'qty') {
          if (self.rows[index].quantityEdit) {
            return true;
          } else {
            evt.preventDefault();
          }
        } else {
          if (self.rows[index].unit_priceEdit) {
            return true;
          } else {
            evt.preventDefault();
          }
        }
        return true;
      }
    },
    calculatePartAmount(index) {
      var self = this;
      let floatUnitPrice = parseFloat(String(self.rows[index].unitPrice).replace(/[^0-9.]/g, ""));
      if (
        self.rows[index].qtyOrdered > 0
        &&
        floatUnitPrice > 0
        &&
        self.rows[index].qtyOrdered != ''
      ) {
        self.rows[index].amount = (self.rows[index].qtyOrdered * floatUnitPrice);
        self.rows[index].amount = "$" + self.amountFormat(self.rows[index].amount);
      } else {
        self.rows[index].amount = "$" + 0;
      }
      self.calculateTotalPartAmounts();
    },
    calculateTotalPartAmounts() {
      var self = this;
      self.subTotal = 0;
      for (const element of self.rows) {
        if (element.amount > 0) {
          element.amount = element.amount.toFixed(2);
        }
        let floatAmount = 0;
        if (element.amount && element.amount != 0 && element.amount != '') {
          floatAmount = parseFloat(String(element.amount).replace(/[^0-9.]/g, ""));
        }
        self.subTotal = self.subTotal + floatAmount;
      }
      self.total = self.subTotal;
    },
    validateRawInput(evt, index) {
      var self = this;
      let floatUnitPrice = parseFloat(String(self.rows[index].unit_price).replace(/[^0-9.]/g, ""));
      if (floatUnitPrice > 999999.99) {
        self.rows[index].unit_priceEdit = false;
      } else {
        self.rows[index].unit_priceEdit = true;
      }
    },
    removeElement: function (index) {
      var self = this;
      if (self.rows.length > 1) {
        if (self.rows[index].purchaseOrderItemId == 0) {
          self.rows.splice(index, 1);
        } else {
          if (confirm('Are you sure that you want to delete this Purchase Order Item? ')) {
            $.ajax({
              url: process.env.ROOT_API + "/customer-purchase-order/item-delete",
              type: "POST",
              data: {'id': self.rows[index].purchaseOrderItemId},
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                if (data.status == "success") {
                  self.rows.splice(index, 1);
                  self.calculateTotalPartAmounts();
                }
              },
              error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR, true, 'remove-customer-po-item');
              },
            });
          }
        }
      }
      self.calculateTotalPartAmounts();
    },
    clearPartRowErrorMsg(index) {
      this.rows[index].partErrorMsg = '';
      this.rows[index].qtyOrderedErrorMsg = '';
      this.rows[index].qtyFilledErrorMsg = '';
      this.rows[index].qtyBackorderedErrorMsg = '';
      this.rows[index].unitPriceErrorMsg = '';
    },
    validatePartRow(index) {
      var self = this;
      var success = true;

      self.clearPartRowErrorMsg(index);

      let floatUnitPrice = parseFloat(String(self.rows[index].unitPrice).replace(/[^0-9.]/g, ""));
      if (self.rows[index].part == null || !self.rows[index].part.value) {
        if (self.rows[index].part == null || !self.rows[index].part.value) {
          self.rows[index].partErrorMsg = "Part is Required.";
          success = false;
        }
      }
      if (
        self.rows[index].qtyOrdered === ''
        ||
        !self.rows[index].qtyOrdered
        ||
        self.rows[index].qtyOrdered === 0
        ||
        self.rows[index].qtyOrdered === '.'
      ) {
        self.rows[index].qtyOrderedErrorMsg = "Quantity is Required.";
        success = false;
      }else{
        if (!/^\d+$/.test(self.rows[index].qtyOrdered)) {
          self.rows[index].qtyOrderedErrorMsg = 'Please enter a valid whole number!';
          success = false;
        }
      }
      if (floatUnitPrice == null || floatUnitPrice <= 0) {
        self.rows[index].unitPriceErrorMsg = "Unit Price is Required.";
        success = false;
      }

      return success;
    },
    addRow: function () {
      var self = this;
      var success = true;
      var hasDuplicate = true;

      if (self.rows.length > 0) {
        success = self.validateAllPartRows();
        hasDuplicate = self.checkDuplicatePart();
      } else {
        hasDuplicate = false;
      }
      if (success && !hasDuplicate) {
        self.addPurchaseOrderItem();
      }
    },
    validateInvoiceRow(index) {
      var self = this;
      var success = true;
      if (this.invoicesRows.length > 0) {
        self.clearInvoiceRowErrorMsg(index);
        if (self.invoicesRows[index].invoiceNumber == '' || self.invoicesRows[index].invoiceNumber == null) {
          self.invoicesRows[index].invoiceNumberErrorMsg = 'Required';
          success = false;
        }
        if (self.invoicesRows[index].invoiceDate == '' || self.invoicesRows[index].invoiceDate == null) {
          self.invoicesRows[index].invoiceDateErrorMsg = 'Required';
          success = false;
        }
        if (self.invoicesRows[index].shipDate == '' || self.invoicesRows[index].shipDate == null) {
          self.invoicesRows[index].shipDateErrorMsg = 'Required';
          success = false;
        }
        if (self.invoicesRows[index].trackingNumber == '' || self.invoicesRows[index].trackingNumber == null) {
          self.invoicesRows[index].trackingNumberErrorMsg = 'Required';
          success = false;
        }
        if (self.invoicesRows[index].carrier == '' || self.invoicesRows[index].carrier == null) {
          self.invoicesRows[index].carrierErrorMsg = 'Required';
          success = false;
        }
      }

      return success;
    },
    clearInvoiceRowErrorMsg(index) {
      this.invoicesRows[index].invoiceNumberErrorMsg = '';
      this.invoicesRows[index].invoiceDateErrorMsg = '';
      this.invoicesRows[index].shipDateErrorMsg = '';
      this.invoicesRows[index].trackingNumberErrorMsg = '';
      this.invoicesRows[index].carrierErrorMsg = '';
    },
    addInvoiceRow() {
      var self = this;
      var index = self.invoicesRows.length - 1;

      var success = self.validateInvoiceRow(index);
      if (success) {
        self.invoicesRows.push({
          id: 0,
          invoiceNumber: '',
          invoiceDate: '',
          shipDate: '',
          trackingNumber: '',
          carrier: '',
          invoiceNumberErrorMsg: '',
          invoiceDateErrorMsg: '',
          shipDateErrorMsg: '',
          trackingNumberErrorMsg: '',
          carrierErrorMsg: ''
        });
      }
    },
    openModal: function () {
      var self = this;
      self.selectedFile = [];
      $("#dnFile").val('');
      self.import_error = '';
      self.generateExcelSample();
      self.importIssue = [];
      $('#item-modal').modal('show');
    },
    generateExcelSample: function () {
      var self = this;
      $.ajax({
        url:
          process.env.ROOT_API +
          "/part-excel/generate",
        type: "POST",
        crossDomain: true,
        dataType: "json",
        headers: {
          'Accept': "application/json",
          "Access-Control-Allow-Origin": "*",
          'Authorization': "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        success: function (data) {
          self.loading = false;
          self.sampleFileName = data.content.file;
          self.sampleFile = data.content.web;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'debt note-import')
        }
      });
    },
    downloadSample() {
      var self = this;
      var docPath = self.sampleFile;
      var save = document.createElement('a');
      save.href = docPath;
      save.download = docPath;
      save.target = '_blank';
      document.body.appendChild(save);
      save.click();
      document.body.removeChild(save);
    },
    removeInvoiceElement(index) {
      var self = this;
      if (self.invoicesRows.length > 1) {
        if (self.invoicesRows[index].id == 0) {
          self.invoicesRows.splice(index, 1);
        } else {
          self.deleteInvoiceRow = true;
          self.rizonSaveModalTitle = "Are you sure you want to delete this invoice item? Please leave a reason for deleting."
          self.invoiceIndexToDelete = index;
          $('#rizonSaveModal').modal('show');
        }
      }
    },
    DeleteInvoiceLineItem() {
      var self = this;
      var index = self.invoiceIndexToDelete;
      var success = true;
      success = self.validateChangeLogMessage();
      if (success) {
        self.loading = true;
        $('#rizonSaveModal').modal('hide');
        $.ajax({
          url: process.env.ROOT_API + "/part-order/invoice-item-delete",
          type: "POST",
          data: {
            'id': self.invoicesRows[index].id,
            'part_order_id': self.partOrderId,
            'change_log_message': self.rizonSaveNotes,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            self.resetRizonModal();
            if (data.status == "success") {
              self.invoicesRows.splice(index, 1);
              self.populateSingleChangeLogRow(data.content);
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.resetRizonModal();
            self.generateStatusCodeMessage(jqXHR, true, 'remove-customer-po-item');
          },
        });
      }
    },
    showSwalPopUp(flag = '', slsId = '', orderNumber = '') {
      var success = true;
      success = this.validateDealerSectionFormFields();
      if (success) {
        var text = '';
        var detailText = '';
        var thirdText = '';
        var icon = '';
        var showConfirmButton = true;
        var showCancelButton = true;
        var confirmButtonText = 'Yes, Submit Order';
        var cancelButtonText = 'No, Make Changes';

        if (flag == 'submit') {
          text = 'Are you sure you want to submit this parts order?';
          detailText = 'Once you submit this order you will not be able to make changes.';
          icon = 'info';
        } else if (flag == 'success') {
          text = 'Thank you for your order!';
          if(slsId != '' && slsId != null){
            detailText = 'Sale ID - ' + slsId + " | " + "Order Number - " + orderNumber;
          }else{
            detailText = "Order Number - " + orderNumber;
          }
          thirdText = `
                    Your order will be processed as quickly as possible.
                    You will receive email updates as the status changes.
                    If you have questions or need support, please contact
                    Rizon Parts at <a href="mailto:RIZONPARTS@RIZONTRUCK.US">RIZONPARTS@RIZONTRUCK.US</a>.`;
          icon = 'success';

          // swal buttons configuration
          // hidding cancel button and changing the text of confirm button
          showConfirmButton = true;
          showCancelButton = false;
          confirmButtonText = 'Close';
        }
        else if (flag == 'error'){
          text = "Order Submission Failed!";
          detailText = "Order Number - " + orderNumber;
          thirdText = "Order Submission has failed! Please contact Admin!"
          icon = 'error';
          showConfirmButton = true;
          showCancelButton = false;
          confirmButtonText = 'Close';
        }

        this.$swal({
          title: text,
          html: `
                    <p class='text-center'>${detailText}</p>
                    ${thirdText ? `<p class='text-center'>${thirdText}</p>` : ''}`,
          type: icon,
          showConfirmButton: showConfirmButton,
          confirmButtonText: confirmButtonText,
          cancelButtonText: cancelButtonText,
          showCancelButton: showCancelButton,
        }).then((result) => {
          if (result.value && flag == 'submit') {
            this.CreatePurchaseOrder(flag);
          }
          // todo handle for the failure flag
        });
      } else {
        this.errorValidationFocus();
      }
    },
    CreatePurchaseOrder(flag) {
      var self = this;
      var success = true;
      var hasDuplicate = false;

      if ((self.isEditPage && self.status != "DRAFT") || flag == "submit") {
        success = self.validateDealerSectionFormFields();
      }

      if (this.shipNewAddress) {
        success = this.validateShipNewAddresses();
      }
      hasDuplicate = this.checkDuplicatePart();
      if (hasDuplicate) {
        success = false;
      }

      if (success) {

        self.loading = true;
        var path = window.location.pathname;
        var segments = path.split("/");


        if (segments[3]) {
          $("#CreatePurchaseOrderBtn").val("Updating ...");
          $("#CreatePurchaseOrderBtn").prop("disabled", true);
          $("#cancelPurchaseOrderBtn").prop("disabled", true);
        } else {
          if (flag == "Save and Continue") {

            $("#createAndContinuePurchaseOrderBtn").val("Saving ...");
            $("#CreatePurchaseOrderBtn").prop("disabled", true);
            $("#createAndContinuePurchaseOrderBtn").prop("disabled", true);
            $("#cancelPurchaseOrderBtn").prop("disabled", true);

          } else {

            $("#CreatePurchaseOrderBtn").val("Saving ...");
            $("#CreatePurchaseOrderBtn").prop("disabled", true);
            $("#createAndContinuePurchaseOrderBtn").prop("disabled", true);
            $("#cancelPurchaseOrderBtn").prop("disabled", true);
          }
        }

        var fields = self.prepareFieldsForDealerSectionSubmission(flag);

        $.ajax({
          url: process.env.ROOT_API + "/part-order/create",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {

            self.loading = false;
            if (segments[3]) {
              $("#CreatePurchaseOrderBtn").val("Update");
              $("#CreatePurchaseOrderBtn").prop("disabled", false);
              $("#cancelPurchaseOrderBtn").prop("disabled", false);
            } else {
              $("#CreatePurchaseOrderBtn").val("Save");
              $("#CreatePurchaseOrderBtn").prop("disabled", false);
              $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
              $("#cancelPurchaseOrderBtn").prop("disabled", false);
            }

            if (data.status == "success") {
              if (flag == 'submit') {
                self.showSwalPopUp('success', data.content.sls_id, data.content.order_number);
              }
              self.showCharges = false;

              if (flag == "generateOrderNumber") {
                self.handleButtonClick();
                self.$router.push("/part-order/edit/" + data.content.id);
              } else {
                self.handleButtonClick();
                self.$router.push("/order-history/list");
              }
            } else {

              if (data.content.length > 0) {
                var err = "";
                for (var i = 0; i < data.content.length; i++) {
                  err += data.content[i] + "<br>";
                }
                $("#errorMsg").html(err);
                $(".alert-warning").toggleClass("show");
                setTimeout(function () {
                  $(".alert-warning").removeClass("show");
                  $(".alert-warning").addClass("hide");
                }, 10000);
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            let errorData = jqXHR.responseJSON;
            if(flag == 'submit'){
              self.status = errorData.content.status;
              self.saleId = errorData.content.sls_id;
              self.disableAllFields = true;
              self.showSwalPopUp('error', errorData.content.sls_id, errorData.content.order_number);
            }else{
              if (segments[3]) {
                $("#CreatePurchaseOrderBtn").val("Update");
                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                $("#cancelPurchaseOrderBtn").prop("disabled", false);
              } else {
                $("#CreatePurchaseOrderBtn").val("Save");
                $("#CreatePurchaseOrderBtn").prop("disabled", false);
                $("#createAndContinuePurchaseOrderBtn").prop("disabled", false);
                $("#cancelPurchaseOrderBtn").prop("disabled", false);
              }
              self.generateStatusCodeMessage(jqXHR, false, 'customer-po-create');
            }
          }
        });
      } else {
        self.errorValidationFocus();
      }
    },
    loadCustomerPurchaseOrder() {

      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/customer-purchase-order/" + self.partOrderId,
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          if (data.status == "success") {
            if (data.content.order_date != null) {
              self.orderDate = data.content.order_date;
              self.orderDateErrorMsg = "";
            } else {
              self.orderDate = "";
              self.orderDateErrorMsg = "Order date is generated when the order is submitted!"
            }
            self.orderJustLoaded = true;
            self.attention = data.content.attention;
            self.orderNumber = data.content.order_number;
            self.status = data.content.status;
            self.dealerPurchaseOrder = data.content.dealer_purchase_order;
            self.comment = data.content.comment; // this is the field comment
            self.agreeLegal = (data.content.agree_legal == 1) ? true : false;
            self.orderedBy = data.content.user_email;
            self.total = data.content.total;
            self.subTotal = data.content.sub_total;
            self.savedDealerShipToId = data.content.dealer_ship_to_location_id;
            self.savedDealerId = data.content.dealer_id;
            self.orderType = data.content.order_type;
            self.repairOrder = data.content.repair_order;
            self.vin = {text: data.content.vin, value: data.content.vehicle_id};
            self.commentArr = data.content.comments; // this is the list of comments
            self.saleId = data.content.sls_id;

            self.populatePartRows(data.content.order_items);
            self.populateInvoiceRows(data.content.billing_records);
            self.populateChangeLogRows(data.content.change_logs);
            self.updateRizonDisabledFields();
            self.disableFieldsIfOrderIsCanceled();
            self.checkOrderStatus();
            self.updateCancellationRequestMessage();
            self.cancelButtonAccess();
            self.reviewCancellationBtnAccessControl();

            self.disableCommentButton = false;
            if (self.status == "REQUESTED-FOR-CANCELLATION") {
              self.disableRizonFields = true;
            }

            if (self.savedDealerId != "" && self.savedDealerId != null) {
              if (!self.loadAllDealers) {
                self.populateDealerId();
              } else {
                self.onSearchDealer(data.content.dealer_code, "loading");
              }
            }

            // after loading all the comments,
            // mark them seen by the loggedin user
            self.markCommentSeen(data.content.comments);
          } else {
            self.loading = false;
          }
        },
        error: function (jqXHR, exception) {
          self.disableAllFields = true;
          self.disableCancelOrder = true;
          self.disableCommentButton = true;
          self.loading = false;
          self.bypassConfirmation = true;
          self.generateStatusCodeMessage(jqXHR, false, 'get-customer-po-detail');
        }
      });
    },
    markCommentSeen(allComments) {
      var self = this;
      if (allComments.length > 0) {
        let commentIds = allComments.map(item => item.id);
        var fields = {
          'ids': commentIds
        }
        $.ajax({
          url: process.env.ROOT_API + "/part-order/mark-comment-seen",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
          },
          error: function (jqXHR, exception) {
            self.generateStatusCodeMessage(jqXHR, true);
          },
        });
      }
    },
    populatePartRows(orderItems) {
      if (orderItems.length < 1) {
        this.addPurchaseOrderItem();
      } else {
        for (let i = 0; i < orderItems.length; i++) {
          if (orderItems[i].part != null) {
            var part = {
              value: orderItems[i].part.id,
              text: orderItems[i].part.vendor_item_number,
              description: orderItems[i].part.name,
              base_price: orderItems[i].part.base_price
            }
            var part_description = orderItems[i].part.name;
            var base_price = orderItems[i].part.base_price;
          } else {
            var part = "";
            var part_description = "";
            var base_price = 0;
          }
          this.rows.push({
            purchaseOrderItemId: orderItems[i].id,
            part: part,
            partDescription: part_description,
            qtyOrdered: orderItems[i].quantity != null ? orderItems[i].quantity : '',
            qtyFilled: orderItems[i].quantity_filled != null ? orderItems[i].quantity_filled : '',
            qtyBackordered: orderItems[i].quantity_backordered != null ? orderItems[i].quantity_backordered : '',
            amount: "$" + this.amountFormat(orderItems[i].total),
            unitPrice: "$" + this.amountFormat(base_price),
            partErrorMsg: '',
            qtyOrderedErrorMsg: '',
            qtyFilledErrorMsg: '',
            qtyBackorderedErrorMsg: '',
            unitPriceErrorMsg: '',
            quantityEdit: true,
            unit_priceEdit: true,
          });
        }
      }

    },
    populateInvoiceRows(invoice_rows) {
      for (let i = 0; i < invoice_rows.length; i++) {
        this.invoicesRows.push({
          id: invoice_rows[i].id,
          invoiceNumber: invoice_rows[i].invoice_number,
          invoiceDate: invoice_rows[i].invoice_date,
          shipDate: invoice_rows[i].ship_date,
          trackingNumber: invoice_rows[i].tracking_number,
          carrier: invoice_rows[i].carrier,
          invoiceNumberErrorMsg: '',
          invoiceDateErrorMsg: '',
          shipDateErrorMsg: '',
          trackingNumberErrorMsg: '',
          carrierErrorMsg: ''
        });
      }
    },
    populateChangeLogRows(changeLogs) {
      this.changeLogRows = [];
      for (let i = 0; i < changeLogs.length; i++) {
        this.populateSingleChangeLogRow(changeLogs[i])
      }
    },
    populateSingleChangeLogRow(changeLog) {
      this.changeLogRows.push({
        id: changeLog.id,
        user: changeLog.created_user,
        date: changeLog.date,
        time: changeLog.time,
        note: changeLog.note
      })
    },
    populateDealerId() {
      for (let i = 0; i < this.dealerArr.length; i++) {
        if (this.dealerArr[i].value == this.savedDealerId) {
          this.dealer_id = this.dealerArr[i];
          break;
        }
      }
    },
    importItem() {
      var self = this;
      self.import_error = "";
      if (self.selectedFile == "" || self.selectedFile == null) {
        self.import_error = "Please Select Excel File.";
        return;
      }
      var fileExtension = ['xls', 'xlsx'];
      if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
        self.import_error = "Only formats are allowed : " + fileExtension.join(', ');
        return;
      }

      $('#importButton').text('Importing');
      $('#importButton').prop('disabled', true);
      $('#cancelButton').prop('disabled', true);

      var formData = new FormData();
      formData.append('myFile', self.selectedFile);

      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/item/import",
        type: "POST",
        data: formData,
        headers: {
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {
            self.rows = [];
            if (data.content != undefined && data.content.length > 0) {
              var dataSet = data.content;
              for (var i = 0; i < dataSet.length; i++) {
                self.rows.push({
                  purchaseOrderItemId: 0,
                  part: dataSet[i].part,
                  partDescription: dataSet[i].part.description,
                  qtyOrdered: dataSet[i].qty,
                  qtyFilled: 0,
                  qtyBackordered: 0,
                  unitPrice: dataSet[i].part.base_price,
                  amount: 0,
                  partErrorMsg: '',
                  qtyOrderedErrorMsg: '',
                  qtyFilledErrorMsg: '',
                  qtyBackorderedErrorMsg: '',
                  unitPriceErrorMsg: '',
                  quantityEdit: true,
                  unit_priceEdit: true,
                });
                self.calculatePartAmount(i);
              }
              self.checkDuplicatePart();
            }
            $('#item-modal').modal('hide');
          } else {
            self.import_error = data.message;
          }
          $('#importButton').text('Import');
          $('#importButton').prop('disabled', false);
          $('#cancelButton').prop('disabled', false);
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          $('#importButton').text('Import');
          $('#importButton').prop('disabled', false);
          $('#cancelButton').prop('disabled', false);
          self.generateStatusCodeMessage(jqXHR, true, 'parts-import-error')
        }
      });
    },
    addComment() {
      var self = this;
      var success = true;
      self.newCommentErrorMsg = "";
      if (self.newComment == "" || self.newComment == null) {
        self.newCommentErrorMsg = "Comment is Required!";
        success = false;
      }

      if (success) {
        self.$swal({
          title: 'Comments Cannot Be Changed or Deleted. Do You Want to Submit?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Submit',
          cancelButtonText: 'No, Cancel',
          showCloseButton: false,
        }).then((result) => {
          if (result.value) {
            // Combine first and last name, adding a space only if both are present
            var userFullName = [self.userObj.first_name, self.userObj.last_name].filter(Boolean).join(' ');
            self.commentArr.unshift({
              'id': '',
              'comment_by': self.userObj.id,
              'comment_by_name': self.userObj.first_name,
              'createdUser': userFullName,
              'part_order_no': self.partOrderId,
              'comment': self.newComment,
              'comment_date': moment().tz('PST8PDT').format('hh:mm A (MM/DD/YYYY)'),
            });

            self.newComment = "";
            self.newCommentErrorMsg = "";
            if (self.isEditPage) {
              self.savePartComment();
            }
            $('#addCommentModal').modal('hide');
          }
        });
      }
    },
    savePartComment() {
      var self = this;
      self.loading = true;

      $.ajax({
        url: process.env.ROOT_API + "/part-order/save-comment",
        type: 'POST',
        data: {
          partOrderId: self.partOrderId,
          comments: self.commentArr,
        },
        headers: self.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'part-order-save-comment')
        }
      });
    },
    PurchaseOrderList() {
      var self = this;
      self.$router.push("/order-history/list");
    },
    clearDealerSectionErrorMessages() {
      this.dealerErrorMsg = "";
      this.dealerShipToErrorMsg = "";
      this.orderDateErrorMsg = "";
      this.orderTypeErrorMsg = "";
      this.dealerPurchaseOrderErrorMsg = "";
      this.commentErrorMsg = "";
      this.agreeLegalErrorMsg = "";
      this.vinErrorMsg = "";
      this.repairOrderErrorMsg = "";
      this.newCommentErrorMsg = "";

      this.newShipToAddress.companyNameErrorMsg = '';
      this.newShipToAddress.addressErrorMsg = '';
      this.newShipToAddress.cityErrorMsg = '';
      this.newShipToAddress.stateErrorMsg = '';
      this.newShipToAddress.zipErrorMsg = '';
    },
    validateDealerSectionFormFields() {
      this.clearDealerSectionErrorMessages();
      var success = true;
      if (this.dealer_id == "" || this.dealer_id == null) {
        this.dealerErrorMsg = "Bill to dealer is required!";
        success = false;
      }
      if (this.shipNewAddress) {
        success = this.validateShipNewAddresses();
      } else {
        if (this.dealerShipId == "" || this.dealerShipId == null) {
          this.dealerShipToErrorMsg = "Ship to location is required!";
          success = false;
        }
      }
      if (this.orderType == "" || this.orderType == null) {
        this.orderTypeErrorMsg = "Order type is required!";
        success = false;
      }
      if (this.dealerPurchaseOrder == "" || this.dealerPurchaseOrder == null) {
        this.dealerPurchaseOrderErrorMsg = "Dealer Purchase Order is required!";
        success = false;
      }
      //
      // if (this.agreeLegal == "" || !this.agreeLegal) {
      //   this.agreeLegalErrorMsg = "You must agree to the legal agreement to place an order!";
      //   success = false;
      // }

      if (this.orderType == 'Vehicle Off Road') {
        if ((this.vin == null || this.vin == '') || (this.vin.value == null || this.vin.value == '')) {
          this.vinErrorMsg = "VIN must be selected when order type is Vehicle Off Road";
          success = false;
        }
        if (this.repairOrder == null || this.repairOrder == '') {
          this.repairOrderErrorMsg = "Repair order must be input when order type is Vehicle Off Road";
          success = false;
        }
      }

      // validation for the part line items
      var partRowSuccess = this.validateAllPartRows();

      if (this.loadAllDealers) {
        var quantitySuccess = this.validateOrderQuantities();
        if (!quantitySuccess) {
          success = quantitySuccess;
        }
      }

      if (success && partRowSuccess) {
        return true;
      } else {
        return false;
      }
    },
    validateShipNewAddresses() {
      var success = true;
      if (this.newShipToAddress.companyName == '' || this.newShipToAddress.companyName == null) {
        this.newShipToAddress.companyNameErrorMsg = "Company Name required!";
        success = false;
      }
      if (this.newShipToAddress.address == '' || this.newShipToAddress.address == null) {
        this.newShipToAddress.addressErrorMsg = "Address required!";
        success = false;
      }
      if (this.newShipToAddress.city == '' || this.newShipToAddress.city == null) {
        this.newShipToAddress.cityErrorMsg = "City required!";
        success = false;
      }
      if (this.newShipToAddress.state == '' || this.newShipToAddress.state == null) {
        this.newShipToAddress.stateErrorMsg = "State required!";
        success = false;
      }
      if (this.newShipToAddress.zip == '' || this.newShipToAddress.zip == null) {
        this.newShipToAddress.zipErrorMsg = "Zip required!";
        success = false;
      }
      if (this.dealer_id == "" || this.dealer_id == null) {
        this.dealerErrorMsg = "Bill to dealer is required when new shipping address is added!";
        success = false;
      }
      return success;
    },
    validateAllPartRows() {
      var overAllSuccess = true;
      for (let i = 0; i < this.rows.length; i++) {
        var success = true;
        var hasDuplicate = false;
        success = this.validatePartRow(i);
        hasDuplicate = this.checkDuplicatePart();

        if (!success || hasDuplicate) {
          overAllSuccess = false;
        }
      }
      return overAllSuccess;
    },
    prepareFieldsForDealerSectionSubmission(flag) {
      var fields = [];
      fields.push({name: "dealer_id", value: this.dealer_id.value});
      fields.push({name: "dealer_ship_id", value: this.dealerShipId.value});
      fields.push({name: "attention", value: this.attention});
      fields.push({name: "ordered_by", value: this.userObj.id});
      fields.push({name: "order_type", value: this.orderType});
      fields.push({name: "dealer_purchase_order", value: this.dealerPurchaseOrder});
      fields.push({name: "order_comment", value: this.comment});
      fields.push({name: "agree_legal", value: this.agreeLegal});
      fields.push({name: "part_rows", value: JSON.stringify(this.rows)});
      fields.push({name: "id", value: this.partOrderId});
      fields.push({name: 'repair_order', value: this.repairOrder});
      fields.push({name: 'total', value: this.total});
      fields.push({name: 'sub_total', value: this.subTotal});
      if (this.orderDate == "" || this.orderDate == null) {
        fields.push({name: "order_date", value: moment().format("MM/DD/YYYY")})
      } else {
        fields.push({name: "order_date", value: this.orderDate});
      }
      if (this.orderType == 'Vehicle Off Road' && this.vin != null && this.vin != '') {
        fields.push({name: 'vehicle_id', value: this.vin.value});
      } else {
        fields.push({name: 'vehicle_id', value: ""});
      }

      if (flag == "submit") {
        fields.push({name: 'order_status', value: "SUBMITTED"});
      } else {
        if (this.isEditPage) {
          fields.push({name: 'order_status', value: this.status});
        } else {
          fields.push({name: 'order_status', value: "DRAFT"});
        }
      }
      if (this.shipNewAddress) {
        fields.push({name: 'new_ship_to_address', value: JSON.stringify(this.newShipToAddress)});
      }

      return fields;

    },
    clearRizonSectionErrorMessages() {
      this.statusErrorMsg = "";
      this.rizonSaveNotesErrorMsg = "";
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 300);
    },
    addPurchaseOrderItem() {
      this.rows.push({
        purchaseOrderItemId: 0,
        part: '',
        partDescription: '',
        qtyOrdered: '',
        qtyFilled: '',
        qtyBackordered: '',
        amount: '',
        unitPrice: '',
        partErrorMsg: '',
        qtyOrderedErrorMsg: '',
        qtyFilledErrorMsg: '',
        qtyBackorderedErrorMsg: '',
        unitPriceErrorMsg: '',
        quantityEdit: true,
        unit_priceEdit: true,
      });
    },
    clearAllSwal() {
      this.$swal({
        title: 'Are you sure you want to clear this part order?',
        type: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.clearAllFields();
        }
      });
    },
    clearAllErrorMsg() {
      this.import_error = '';
      this.dealerErrorMsg = '';
      this.dealerShipToErrorMsg = '';
      this.orderDateErrorMsg = '';
      this.orderTypeErrorMsg = '';
      this.dealerPurchaseOrderErrorMsg = '';
      this.commentErrorMsg = '';
      this.agreeLegalErrorMsg = '';
      this.vinErrorMsg = '';
      this.repairOrderErrorMsg = '';
      this.statusErrorMsg = '';
      this.rizonSaveNotesErrorMsg = '';
      this.newCommentErrorMsg = '';

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i].partErrorMsg = '';
          this.rows[i].qtyOrderedErrorMsg = '';
          this.rows[i].qtyFilledErrorMsg = '';
          this.rows[i].qtyBackorderedErrorMsg = '';
          this.rows[i].unitPriceErrorMsg = '';
        }
      }
    },
    clearAllFields() {
      this.dealer_id = '';
      this.dealerCompanyName = '';
      this.dealerAddress_1 = '';
      this.dealerAddress_2 = '';
      this.dealerCity = '';
      this.dealerState = '';
      this.dealerZip = '';

      this.dealerShipId = '';
      this.shipToCompanyName = '';
      this.shipToAddress_1 = '';
      this.shipToAddress_2 = '';
      this.shipToCity = '';
      this.shipToState = '';
      this.shipToZip = '';

      this.attention = '';
      this.orderType = '';
      this.dealerPurchaseOrder = '';
      this.comment = '';

      this.rows = [];
      this.addPurchaseOrderItem();

      this.subTotal = 0;
      this.total = 0;

      this.agreeLegal = false;
      this.newComment = '';
      this.newCommentCharsCount = 0;
      this.commentArr = [];

      if (this.isRizonRep) {
        this.dealerArr = [];
        this.dealerShipTo = [];
      } else {
        this.dealer_id = this.dealerArr[0];
      }

      this.clearAllErrorMsg();
      this.scrollToTop();
      this.loading = false;
    },
    saveInvoiceDetails() {
      var success = this.validateRizonSectionFormFields();
      if (success) {
        $('#rizonSaveModal').modal('show');
      }
    },
    AddInvoiceDetails() {
      var self = this;
      var success = true;
      success = self.validateChangeLogMessage();


      if (success) {
        $('#rizonSaveModal').modal('hide');

        self.loading = true;
        var path = window.location.pathname;

        var fields = self.prepareFieldsForRizonSectionSubmission();

        $.ajax({
          url: process.env.ROOT_API + "/part-order/create-invoice-details",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {

            self.loading = false;


            if (data.status == "success") {
              self.showCharges = false;
              self.handleButtonClick();
              self.$router.push("/order-history/list");

            } else {

              if (data.content.length > 0) {
                var err = "";
                for (var i = 0; i < data.content.length; i++) {
                  err += data.content[i] + "<br>";
                }
                $("#errorMsg").html(err);
                $(".alert-warning").toggleClass("show");
                setTimeout(function () {
                  $(".alert-warning").removeClass("show");
                  $(".alert-warning").addClass("hide");
                }, 10000);
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false, 'customer-po-create');
          }
        });
      }
    },
    validateRizonSectionFormFields() {
      this.clearRizonSectionErrorMessages();
      var success = true;
      if (this.status == "" || this.status == null) {
        this.statusErrorMsg = "Status needs to be selected!";
        success = false;
      }

      // validation for the part line items
      var invoiceRowSuccess = this.validateAllInvoiceRows();

      if (success && invoiceRowSuccess) {
        return true;
      } else {
        return false;
      }
    },
    validateChangeLogMessage() {
      this.clearRizonSectionErrorMessages();
      var success = true;

      if (this.rizonSaveNotes == "" || this.rizonSaveNotes == null) {
        this.rizonSaveNotesErrorMsg = "Change log needs to be added!";
        success = false;
      }
      return success;
    },
    validateAllInvoiceRows() {
      var overAllSuccess = true;
      if (this.invoicesRows.length > 0) {
        for (let i = 0; i < this.invoicesRows.length; i++) {
          var success = this.validateInvoiceRow(i);
          if (!success) {
            overAllSuccess = success;
          }
        }
      }
      return overAllSuccess;
    },
    prepareFieldsForRizonSectionSubmission() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var fields = [];

      fields.push({name: "id", value: segments[3]});
      fields.push({name: 'order_status', value: this.status});
      fields.push({name: 'invoice_rows', value: JSON.stringify(this.invoicesRows)});
      fields.push({name: 'change_log', value: this.rizonSaveNotes});

      return fields;

    },
    resetRizonModal() {
      this.rizonSaveModalTitle = "Add Notes";
      this.rizonSaveNotes = "";
      this.rizonSaveNotesErrorMsg = "";
      this.deleteInvoiceRow = false;
      this.invoiceIndexToDelete = 0;
      $('#rizonSaveModal').modal('hide');
    },
    processOrder() {
      var self = this;
      if (confirm('Are you sure that you want to process this order? ')) {
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/part-order-process",
          type: "POST",
          data: {'id': self.partOrderId},
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              self.status = data.content;
              self.updateRizonDisabledFields();
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, true);
          },
        });
      }
    },
    updateRizonDisabledFields() {
      if (this.isRizonRep) {
        if (this.status == "DRAFT" || this.status == "SUBMITTED") {
          this.disableRizonFields = true;
        } else {
          this.disableRizonFields = false;
        }
      }

    },
    handleButtonClick() {
      // Set the flag to bypass the confirmation dialog
      this.bypassConfirmation = true;
    },
    orderCancellationCheck() {
      // validate if the order is eligible to be canceled or not.
      // check if the invoice rows are empty or not
      if (this.status == "INVOICED" || this.status == "SHIPPED" || this.status == "PARTIALLY SHIPPED") {
        // not eligible for cancellation
        // need to show modal accordingly
        $('#orderCancelIneligibleModal').modal('show');
      } else {
        // eligible for cancellation
        // need to show modal accordingly
        $('#orderCancelModal').modal('show');
      }
    },
    cancelOrder() {
      var self = this;

      // verify if cancellation is reason is given or not
      var success = self.validateCancellationReason();
      if (success) {
        self.loading = true;
        $('#orderCancelModal').modal('hide');
        var fields = {
          'id': self.partOrderId,
          'reasonForCancellation': self.reasonForCancellation,
          'status': "REQUESTED-FOR-CANCELLATION"
        }
        $.ajax({
          url: process.env.ROOT_API + "/part-order/cancellation-request",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              self.status = data.content.status;
              self.commentArr = data.content.comments;
              self.disableFieldsIfOrderIsCanceled();
              self.cancelButtonAccess();
              self.clearAllErrorMsg();
              self.reviewCancellationBtnAccessControl();
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, true);
          },
        });
      }
    },
    validateCancellationReason() {
      var success = true;
      this.reasonForCancellationErrorMsg = "";
      if (this.reasonForCancellation == '' || this.reasonForCancellation == null) {
        this.reasonForCancellationErrorMsg = "Cancellation reason is required!";
        success = false
      }
      return success;
    },
    disableFieldsIfOrderIsCanceled() {
      if (this.status == 'REQUESTED-FOR-CANCELLATION' || this.status == 'CANCELED') {
        this.disableAllFields = true;
      }
    },
    orderCancelReview(flag) {
      // check if comment has been added or not
      var self = this;
      var success = self.validateApprovalDenialReason();
      if (success) {
        self.loading = true;
        $('#orderCancelReview').modal('hide');
        var fields = {
          'flag': flag,
          'comment': self.approvalDenialReason,
          'id': self.partOrderId,
        }
        $.ajax({
          url: process.env.ROOT_API + "/part-order/cancellation",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              self.status = data.content.status;
              self.commentArr = data.content.comments;
              self.populateChangeLogRows(data.content.changeLog);
              self.updateRizonDisabledFields();
              self.disableFieldsIfOrderIsCanceled();
              self.cancelButtonAccess();
              self.reviewCancellationBtnAccessControl();
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, true);
          },
        });
      }
    },
    validateApprovalDenialReason() {
      this.approvalDenialReasonErrorMsg = "";
      if (this.approvalDenialReason == "" || this.approvalDenialReason == null) {
        this.approvalDenialReasonErrorMsg = "Comment is required";
        return false;
      } else {
        return true;
      }
    },
    /**
     * Disables all form fields if the order status is not 'DRAFT'.
     * Keeps the fields enabled only if the status is 'DRAFT'.
     */
    checkOrderStatus() {
      if (
        this.status
        &&
        !this.isRizonRep
      ) {
        this.disableAllFields = this.status !== 'DRAFT';
      }
    },
    generateOrderNumber() {
      this.CreatePurchaseOrder('generateOrderNumber');
    },
    updateCancellationRequestMessage() {
      if (this.status == "DRAFT") {
        this.cancellationRequestMsg = "Since the order is in DRAFT status, it will be canceled directly."
      } else {
        this.cancellationRequestMsg = "Orders may only be canceled if they have NOT been invoiced or if NO tracking number has been issued.";
      }
    },
    cancelButtonAccess() {
      if (
        !this.isEditPage
        ||
        this.loadAllDealers
        ||
        this.status == "CANCELED"
        ||
        this.status == "REQUESTED-FOR-CANCELLATION"
      ) {
        this.disableCancelOrder = true;
      } else {
        this.disableCancelOrder = false;
      }
    },
    reviewCancellationBtnAccessControl() {
      if (this.status == "REQUESTED-FOR-CANCELLATION") {
        this.showReviewButton = true;
      } else {
        this.showReviewButton = false;
      }
    },
    populateFormData(populateInitialData = false) {
      var formData = {
        dealer_id: this.dealer_id,
        dealerShipId: this.dealerShipId,
        newShipToAddress: this.newShipToAddress,
        orderDate: this.orderDate,
        attention: this.attention,
        orderedBy: this.orderedBy,
        orderType: this.orderType,
        dealerPurchaseOrder: this.dealerPurchaseOrder,
        comment: this.comment,
        vin: this.vin,
        repairOrder: this.repairOrder,
        rows: this.rows,
        agreeLegal: this.agreeLegal,
        status: this.status,
        invoiceRows: this.invoiceRows,
      }
      this.partOrderFormData = JSON.stringify(formData);

      if (populateInitialData) {
        this.populateIntialFormData();
      }
    },
    populateIntialFormData() {
      this.initialPartOrderFormData = this.partOrderFormData;
    },
    hasFormChanged() {
      // Compare the current form data with the initial form data
      return this.partOrderFormData !== this.initialPartOrderFormData;
    },
    validateOrderQuantities() {
      var success = true;
      var overAllSuccess = true;
      for (let i = 0; i < this.rows.length; i++) {
        success = this.validateOrderQuantitiesRow(i);
        if (!success) {
          overAllSuccess = false;
        }
      }
      return overAllSuccess;
    },
    validateOrderQuantitiesRow(index) {
      this.rows[index].qtyFilledErrorMsg = "";
      this.rows[index].qtyBackorderedErrorMsg = "";
      var success = true;
      var qtyBackordered = parseFloat(String(this.rows[index].qtyBackordered).replace(/[^0-9.]/g, ""));
      var qtyFilled = parseFloat(String(this.rows[index].qtyFilled).replace(/[^0-9.]/g, ""));

      var totalOrdered = qtyBackordered + qtyFilled;
      if (this.rows[index].qtyOrdered != totalOrdered) {
        this.rows[index].qtyFilledErrorMsg = "Sum of qty filled and backordered must equal qty ordered!";
        this.rows[index].qtyBackorderedErrorMsg = this.rows[index].qtyFilledErrorMsg;
        success = false;
      }
      return success;
    },
    validateQty(event, row){
      const value = event.target.value;
      if (!/^\d+$/.test(value)) {
        row.qtyOrderedErrorMsg = 'Please enter a valid whole number!';
      }else{
        row.qtyOrderedErrorMsg = '';
      }
    }
  }
};

</script>

<style scoped>
.order-part-header {
  position: sticky;
  top: 65px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.header-font {
  font-size: 18px;
}

.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerPurchaseOrderCreate.vue